let pendingToken: string | null = null;

// Run synchronously before Angular/bootstrap, third parties or route tracking.
// A fragment never reaches SSR/proxy logs. Remove it before any browser tag can
// inspect the URL, keeping the credential only in this module's memory.
export function captureRecoveryLink(): void {
  if (
    typeof window === 'undefined' ||
    window.location.pathname !== '/baixar-ingressos/confirmar'
  )
    return;
  const match = /^#token=([A-Za-z0-9_-]{43})$/.exec(window.location.hash);
  pendingToken = match?.[1] ?? null;
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname
  );
}

export function takeRecoveryToken(): string | null {
  const token = pendingToken;
  pendingToken = null;
  return token;
}

export function isPrivateTicketPage(path: string): boolean {
  return /^\/(?:baixar-ingressos|tickets)(?:\/|$)/.test(path);
}

export function protectTicketHtml(html: string, path: string): string {
  if (!isPrivateTicketPage(path)) return html;
  return html.replace(
    /<script\b(?=[^>]*\bsrc\s*=\s*["']https:\/\/pagead2\.googlesyndication\.com\/pagead\/js\/adsbygoogle\.js(?:\?[^"']*)?["'])[^>]*>\s*<\/script>/gi,
    ''
  );
}
